module.exports = __webpack_public_path__ + "media/application/images/svgs/triangle-a9574d86b367e3bba8e4cbb00f30313a.svg";